export async function getCountryCode() {
    let countryCode = null;
    try {
        const response = await fetch('https://ip2c.org/s');
        const data = await response.text();
        countryCode = data.toString().split(';')[1];
    } catch (err) {
        console.log(err);
        throw err;
    }
    return countryCode;
};